import { CommonModule } from '@angular/common';
import {
  Component,
  HostBinding,
  Input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseWidget } from '@app/widgets/base-widget/base-widget';

@Component({
  selector: 'feedback-form',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './feedback-form.component.html',
  styleUrl: './feedback-form.component.scss',
})
export class FeedbackFormComponent extends BaseWidget implements OnInit {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  cssClassMap: Map<number, String> = new Map();
  cssStylesMap: Map<number, any> = new Map();
  selectedValues: WritableSignal<string[]> = signal([]);
  rating: WritableSignal<number> = signal(null);

  @Input() actionEvent: (event: any) => void;
  @Input() slot: any;
  constructor(private route: ActivatedRoute) {
    super();
  }
  ngOnInit(): void {
    this.rating.set(Number(this.route.snapshot.queryParamMap.get('rating')));
  }

  updateSelectedValues(option: string, event: any) {
    if (event.target.checked) {
      this.selectedValues().push(option);
    } else {
      this.selectedValues.set(
        this.selectedValues().filter((value) => value !== option),
      );
    }
  }

  onActionCall(action: any, comments: string) {
    action.params.additionalComments = comments;
    action.params.npsFormInput = this.selectedValues().join(', ');
    action.params.npsRating = this.rating();
    this.actionEvent({
      actionData: { ...action },
    });
  }
}
